/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListString } from '../../models/api-response-list-string';

export interface ListDocumentTypes$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listDocumentTypes(http: HttpClient, rootUrl: string, params: ListDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
  const rb = new RequestBuilder(rootUrl, listDocumentTypes.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListString>;
    })
  );
}

listDocumentTypes.PATH = '/v1/api/admin-ui/agent-context/document-types';
